import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import { sanitizeConfigOptions } from "@labxchange/util-sanitization";

import {
  textBodyWrapperClasses,
  textBodyAlignmentClass,
  resolveTextBodyCustomColor,
} from "./utils";
import className from "../style.module.scss";

export function TextBody(props) {
  const custom = resolveTextBodyCustomColor(props.customColor);

  const wrapperClasses = [
    className.textBodyWrapper,
    ...textBodyWrapperClasses(props.theme),
  ].join(" ");

  const bodyClasses = [
    className.textBody,
    props.textBodyIsSmall ? className.small : "",
    textBodyAlignmentClass(props.textAlign),
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      id={`textBody${props.id}`}
      className={wrapperClasses}
      // Overrides only `--tbw-bg`/`--tbw-text`/`--tbw-blur` when the scene sets a
      // customColor; the preset keeps supplying the border and drop shadow.
      style={
        custom
          ? {
              "--tbw-bg": custom.background,
              "--tbw-text": custom.text,
              "--tbw-blur": custom.blur,
            }
          : undefined
      }
      // A handful of mid-tones (greys around #777) clear 4.5:1 against none of
      // the three text colours. Publishing the achieved ratio gives authors and
      // the e2e suite something to check, since a custom colour is free-form
      // input with no other feedback loop.
      data-tbw-custom-contrast={custom ? custom.contrast : undefined}
    >
      <div
        className={bodyClasses}
        tabIndex={-1}
        style={{
          fontSize: props.textBodyIsSmall
            ? `calc(6/100*${props.textBodyWidth}px)`
            : null,
          // The small state hides the glyphs and smears this shadow in their
          // place. The colour comes from the palette's own `--tbw-blur` so the
          // blurred preview stays legible against its background.
          textShadow: props.textBodyIsSmall
            ? `0 0 ${(1.75 / 100) * props.textBodyWidth}px var(--tbw-blur)`
            : null,
          padding:
            props.textBodyHeight < 75 || props.textBodyIsSmall ? "16px" : null,
        }}
      >
        <FormattedMessage
          string={props.text}
          sanitizeConfig={sanitizeConfigOptions.BlockText}
          description=""
        />
      </div>
    </div>
  );
}

TextBody.propTypes = {
  id: PropTypes.string.isRequired,
  textBodyIsSmall: PropTypes.bool.isRequired,
  textBodyWidth: PropTypes.number.isRequired,
  textBodyHeight: PropTypes.number,
  text: PropTypes.string.isRequired,
  theme: PropTypes.string,
  textAlign: PropTypes.string,
  customColor: PropTypes.string,
};
